<template>
  <div>
    <h1>{{ $t("settings.users.userEdit") }}</h1>

    <div class="mt-3 elevation-12 grey lighten-4">
      <user-settings-menu />
      <v-card>
        <v-card-text>
          <v-alert type="info"
            >{{ $t("settings.users.costCentre.alert.text") }}
            <router-link class="text--secondary" to="/settings/cost-centre"> {{ $t("settings.users.costCentre.alert.href") }}.</router-link>
          </v-alert>
          <v-form lazy-validation ref="form" v-model="formValid">
            <h2>{{ $t("settings.users.costCentre.title") }}</h2>
            {{ $t("settings.users.costCentre.description") }}
            <v-data-table :headers="headers" :items="allCostCentres" :search="search" show-select v-model="currentCostCentres" disable-sort sor>
              <template #item="props">
                <tr>
                  <td>
                    <v-checkbox hide-details primary @change="props.select" v-model="props.isSelected" class="ma-0 pa-0" />
                  </td>
                  <td class="text-left">{{ props.item.list_order }}</td>
                  <td class="text-left">{{ props.item.name }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-select
              :items="currentCostCentres"
              :label="$t('settings.users.costCentre.defaultCostCentre')"
              clearable
              item-text="name"
              item-value="id"
              v-model="defaultCostCentre"
            >
            </v-select>
          </v-form>
        </v-card-text>
      </v-card>

      <v-card>
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="cancel()" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click.native="save()" color="blue darken-1" text>{{ $t("global.save") }} </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import UserSettingsMenu from "../../../../components/Settings/Users/UserSettingsMenu";

export default {
  name: "SettingsUserEditCostCentreView",
  components: { UserSettingsMenu },
  data: () => ({
    currentCostCentres: [],
    defaultCostCentre: null,
    formValid: true,
    search: null,
    allCostCentres: [],
    preChanges: null
  }),
  created() {
    this.axios
      .get("settings/user/get-cost-centre", {
        params: { userId: this.$route.params.id }
      })
      .then(resp => {
        this.allCostCentres = [];
        for (let costCentre of resp.data.allCostCentres) {
          this.allCostCentres.push({
            id: costCentre.id,
            name: costCentre.name,
            list_order: costCentre.list_order
          });
          if (costCentre.isAssigned) {
            this.currentCostCentres.push({
              id: costCentre.id,
              name: costCentre.name,
              list_order: costCentre.list_order
            });
          }
        }
        this.defaultCostCentre = resp.data.defaultCostCentre == null ? null : resp.data.defaultCostCentre.id;
        this.preChanges = JSON.stringify({
          currentCostCentres: this.currentCostCentres,
          defaultCostCentre: this.defaultCostCentre
        });
      });
  },
  watch: {
    currentCostCentres() {
      if (this.formChanged && typeof this.currentCostCentres.find(v => v.id === this.defaultCostCentre) === "undefined") {
        this.defaultCostCentre = null;
      }
    }
  },
  computed: {
    headers() {
      return [
        { text: this.$t("global.ordinate"), value: "list_order" },
        { text: this.$t("global.itemName"), value: "name" }
      ];
    }
    // selectedCostCentres() {
    //   return this.allCostCentres.filter(v => this.currentCostCentres.includes(v));
    // }
  },
  methods: {
    formChanged() {
      return (
        this.preChanges !==
        JSON.stringify({
          currentCostCentres: this.currentCostCentres,
          defaultCostCentre: this.defaultCostCentre
        })
      );
    },
    cancel() {
      this.$router.push("/settings/users");
    },
    save() {
      this.axios
        .post("settings/user/save-cost-centre", {
          userId: this.$route.params.id,
          defaultCostCentre: this.defaultCostCentre,
          currentCostCentres: this.currentCostCentres
        })
        .then(() => {
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
          this.nonChangeUser = this.user;
          this.preChanges = JSON.stringify({
            currentCostCentres: this.currentCostCentres,
            defaultCostCentre: this.defaultCostCentre
          });
        });
    }
  },
  beforeRouteLeave(from, to, next) {
    if (this.formChanged()) {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("global.saveBeforeExit.content"),
        title: this.$t("global.saveBeforeExit.title"),
        customButtons: [
          { text: this.$t("global.cancel"), value: "cancel" },
          { text: this.$t("global.no"), value: "no" },
          { text: this.$t("global.yes"), color: "primary", value: "yes" }
        ]
      });
      result.then(chosen => {
        if (chosen === "cancel") {
          next(false);
        } else if (chosen === "no") {
          next();
        } else if (chosen === "yes") {
          this.axios
            .post("settings/user/save-cost-centre", {
              userId: this.$route.params.id,
              defaultCostCentre: this.defaultCostCentre,
              currentCostCentres: this.currentCostCentres
            })
            .then(() => {
              this.$store.dispatch("snackbarPush", {
                text: this.$t("global.saved"),
                position: "down"
              });
              next();
            });
        }
      });
    } else {
      next();
    }
  }
};
</script>

<style scoped></style>
